/**
 * Domain badges — clinical drapeau, result status, escalade status. Every clinical state is
 * color + glyph + text (never color alone — daltonisme + médico-légal); the Badge primitive injects
 * the mandated glyph for clinical tones automatically.
 */
import { Badge } from "@/ui";
import { useT } from "@/app";
import { drapeauToClinical, type Drapeau, type StatutEscalade, type StatutResultat } from "../types";

export function FlagBadge({ drapeau }: { drapeau: Drapeau | null | undefined }) {
  const { t } = useT();
  const clinical = drapeauToClinical(drapeau);
  const label =
    drapeau === "critique"
      ? t("validation.flag.critique")
      : drapeau === "haut"
        ? t("validation.flag.haut")
        : drapeau === "bas"
          ? t("validation.flag.bas")
          : t("validation.flag.normal");
  return <Badge tone={clinical}>{label}</Badge>;
}

export function ResultStatusBadge({ statut, isCorrection }: { statut: StatutResultat; isCorrection?: boolean }) {
  const { t } = useT();
  if (isCorrection) return <Badge tone="warn">{t("validation.status.correction")}</Badge>;
  if (statut === "repris") return <Badge tone="info">{t("validation.status.repris")}</Badge>;
  return <Badge tone="neutral">{t("validation.status.brut")}</Badge>;
}

const ESCALADE_TONE: Record<StatutEscalade, "high" | "success" | "critical"> = {
  a_acquitter: "high",
  acquitte: "success",
  echec: "critical",
};

export function EscaladeStatusBadge({ statut }: { statut: StatutEscalade }) {
  const { t } = useT();
  return <Badge tone={ESCALADE_TONE[statut]}>{t(`validation.escalade.statut.${statut}`)}</Badge>;
}
